<hbo-datatable-smart *ngIf="teams$ | async as teams"
  [columns]="['id', 'name', 'entity']"
  [items]="teams" (reload)="searchTeams($event, true)"
>
  <tbody class="table-group-divider accordion" id="accordionTeam">
    <ng-container *ngFor="let team of teamsCollection$">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + team.id"> </button></th>
        <td>{{ team.id }}</td>
        <td>{{ team.name }}</td>
        <td>{{ team.entity.name | titlecase }}</td>
      </tr>
      <tr class="row-body">
        <td colspan="6" class="bg-light p-0">
          <div [id]="'collapse-' + team.id" class="accordion-collapse collapse" data-bs-parent="#accordionTeam">
            <div class="accordion-body">
              <hbo-team-actions [team]="team" [user]="user" (reload)="searchTeams({}, true)" (callback)="callback($event)"></hbo-team-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!teams.data.length">
      <td colspan="6" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>
